module.exports = __webpack_public_path__ + "static/coding_interactions_dynamic_11_do-79b5144b69cbd0d034f5f4be84c66a7b.png";